export default "__VITE_ASSET__d005f9c3__"